module.exports = __webpack_public_path__ + "static/parallax-bg-3a7adcc5f3427b19b7bc2b7e26d83052.png";